export default "__VITE_ASSET__BUmf94cX__"